<template>
  <div>
    <b-row>
      <b-col>
        <b-table class="table-sm text-center" responsive outlined hover head-variant="light" :no-local-sorting=true
          :sort-by.sync="filters.sort_field" :sort-desc.sync="filters.sort_order" :fields="tableFields"
          :items="detections">
          <template v-slot:cell(id)="{ item }">
            <table class="item-info">
              <tr>
                <td>ID:</td>
                <td>{{ item.detection_uuid }}</td>
              </tr>
              <tr>
                <td>Created:</td>
                <td>{{ momentf(item.created_at) }}</td>
              </tr>
            </table>
          </template>
          <template v-slot:cell(tags)="{ item }">
            <b-badge v-for="tag in item.tags_data" :key="tag.id" class="mx-1">{{ tag.name }}</b-badge>
          </template>
          <template v-slot:cell(files)="{ item }">
            <FilesPreviewSlider :files="item.files" :set_id="item.detection_set_id" image_type="detection" @image_click="openViewerModal(item, $event)" :can_click_image="true"/>
          </template>
          <template v-slot:cell(parsed_data)="{ item }">
            <table class="item-parsed-data">
              <tr v-for="parsed_data in item.parsed_data" :key="parsed_data.key">
                <td>{{ parsed_data.name }}</td>
                <td>
                  <template v-if="parsed_data.type_name === 'Timestamp' || parsed_data.type_name === 'Timestamp Array'">
                    <template v-if="typeof (parsed_data.value) === 'object'">
                      [<span v-for="(arrayitem, index) in parsed_data.value" :key="index">{{ momentf(arrayitem) }}, </span>]
                    </template>
                    <template v-else>
                      {{ momentf(parsed_data.value) }}
                    </template>
                  </template>
                  <template v-else>
                    {{ parsed_data.value }}
                  </template>
                </td>
              </tr>
            </table>
          </template>
          <template v-slot:cell(options)="{ item }">
            <div class="flex-container options-center">
              <router-link v-if="item.actions.update"
                :to="{ name: 'DetectionUpdate', params: { project_id: item.project_id, detection_set_id: item.detection_set_id, id: item.detection_id } }">
                <a><i class="mx-1 fa fa-edit fa-lg" /></a>
              </router-link>
              <div>
                <i class="fa fa-trash fa-danger fa-lg" v-if="item.actions.delete"
                  @click="$emit('sendForDelete', item.detection_id)" />
              </div>
            </div>
          </template>
          <template v-slot:cell(select)="{ item }">
            <div class="flex-container options-center">
              <b-form-checkbox v-model="selectedIds" :value="item.detection_id" />
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <ImageViewerModal ref="imageViewerModal"/>
  </div>
</template>
<script>
import FilesPreviewSlider from '@/views/Shared/FilesPreviewSlider.vue';
import ImageViewerModal from '@/views/Shared/ImageViewerModal.vue';

export default {
  props: {
    tableFields: {
      value: Array,
      required: true
    },
    filters: {
      value: Object,
      required: true
    },
    detections: {
      value: Array,
      required: true
    },
  },
  components: {
    FilesPreviewSlider,
    ImageViewerModal
  },
  data() {
    return {
      selectedIds: []
    };
  },
  watch: {
    selectedIds() {
      this.$emit('selected', this.selectedIds);
    },
  },
  methods: {
    clearSelected() {
      this.selectedIds = [];
    },
    openViewerModal(item, file) {
      let fileIndex = item.files.findIndex(f => f.id == file.id);
      this.$refs.imageViewerModal.openModal(item.files, fileIndex, item.detection_set_id, 'detection');
    }
  },
};
</script>
<style lang="scss">
.item-info {
  border: none;
  text-align: left;

  td {
    border: none;
    padding: 0 0.25rem;

    &:first-child {
      font-weight: bold;
    }
  }
}

.item-parsed-data {
  border: none;
  text-align: left;

  td {
    border: none;
    font-size: 0.8rem;
    padding: 0 0.25rem;

    &:first-child {
      font-weight: bold;
    }
  }
}
</style>
